export const menuItems = [{
        id: 1,
        perm: "view_dashboard",
        label: "Dashboard",
        icon: "bx-home-circle",
        link: "/"
    },
    {
        id: 2,
        perm: "new_sale",
        actionpage: "1",
        label: "menuitems.order.text",
        icon: "bx-cart",
        link: "/sales/order"
    },
    {
        id: 3,
        perm: "products_tab",
        label: "menuitems.products.text",
        icon: "bx-grid",
        subItems: [{
                id: 4,
                perm: "add_products",
                actionpage: "1",
                label: "Add Products",
                link: "/products/add_product",
                parentId: 3
            },
            {
                id: 5,
                perm: "view_products",
                label: "Search Products",
                link: "/products/search_products",
                parentId: 3
            },
            {
                id: 6,
                perm: "view_products",
                label: "menuitems.products.list.view",
                link: "/products/view",
                parentId: 3
            },
            {
                id: 7,
                perm: "view_product_categories",
                label: "menuitems.products.list.categories",
                link: "/categories/view",
                parentId: 3
            }
        ]
    },
    {
        id: 8,
        perm: "expenses_tab",
        label: "menuitems.expenses.text",
        icon: "bx-food-menu",
        subItems: [{
                id: 9,
                perm: "view_expenses",
                actionpage: "1",
                label: "menuitems.expenses.list.view",
                link: "/expenses/view",
                parentId: 8
            },
            {
                id: 10,
                perm: "view_expense_categories",
                actionpage: "1",
                label: "menuitems.expenses.list.categories",
                link: "/expenses/categories",
                parentId: 8
            },
            {
                id: 11,
                perm: "view_expenses_report",
                label: "menuitems.expenses.list.report",
                link: "/expenses/report",
                parentId: 8
            },
        ]
    },
    {
        id: 12,
        perm: "advanced_features_tab",
        actionpage: "1",
        label: "Finance Section",
        icon: "bxs-folder-open",
        subItems: [{
                id: 13,
                perm: "view_payment_options",
                label: "Payment Options",
                link: "/payment/options",
                parentId: 12
            },
            {
                id: 14,
                perm: "view_money_transfers",
                label: "Money Transfers",
                link: "/payment/transfers",
                parentId: 12
            }      
        ]
    },
    {
        id: 15,
        perm: "advanced_features_tab",
        actionpage: "1",
        label: "Customer Management",
        icon: "bxs-folder-open",
        subItems: [{
                id: 16,
                perm: "view_customers",
                label: "Customers",
                link: "/customers",
                parentId: 15
            }, 
            {
                id: 17,
                perm: "view_customer_deposits",
                label: "Customer Deposits",
                link: "/customer/deposits",
                parentId: 15
            },
            {
                id: 18,
                perm: "view_customer_balances",
                label: "Customer Balances",
                link: "/customer/balances",
                parentId: 15
            },
            {
                id: 19,
                perm: "view_customer_deposits",
                label: "Customer Refund",
                link: "/customer/deposit_refund",
                parentId: 15
            },           
        ]
    },
    {
        id: 20,
        perm: "advanced_features_tab",
        actionpage: "1",
        label: "System Settings",
        icon: "bxs-folder-open",
        subItems: [{
                id: 21,
                perm: "view_general_settings",
                label: "General Settings",
                link: "/settings/general",
                parentId: 20
            }, 
            {
                id: 22,
                perm: "view_receipt_settings",
                label: "Receipt Settings",
                link: "/settings/receipt",
                parentId: 20
            },
            {
                id: 23,
                perm: "view_user_roles",
                label: "User Roles",
                link: "/users/groups",
                parentId: 20
            },
            {
                id: 24,
                perm: "manage_permissions",
                label: "Permissions",
                link: "/users/permissions",
                parentId: 20
            },
            {
                id: 25,
                perm: "view_users",
                label: "Users",
                link: "/users",
                parentId: 20
            }, 
            {
                id: 26,
                perm: "view_staff",
                label: "Staff",
                link: "/staff",
                parentId: 20
            },      
        ]
    },
    {
        id: 27,
        perm: "reports_tab",
        actionpage: "1",
        label: "menuitems.reports.text",
        icon: "bxs-folder-open",
        subItems: [{
                id: 28,
                perm: "view_sales_report",
                label: "menuitems.reports.list.sreport",
                link: "/sales",
                parentId: 27
            },
            {
                id: 29,
                perm: "view_payments_report",
                label: "Payments Report",
                link: "/payments",
                parentId: 27
            },
            {
                id: 30,
                perm: "view_debtors_report",
                label: "menuitems.reports.list.debtor",
                link: "/sales/debtors",
                parentId: 27
            },
            {
                id: 31,
                perm: "view_sales_report",
                label: "Discounts Allowed",
                link: "/sales/discounts",
                parentId: 27
            },
        ]
    },
    {
        id: 32,
        perm: "reports_tab",
        actionpage: "1",
        label: "Management Reports",
        icon: "bxs-folder-open",
        subItems: [{
                id: 33,
                perm: "view_transactions_report",
                label: "Transactions Report",
                link: "/advanced_reports/transactions_report",
                parentId: 32
            },
            {
                id: 34,
                perm: "view_sales_report",
                label: "menuitems.reports.list.sreport",
                link: "/advanced_reports/sales_report",
                parentId: 32
            },            
            {
                id: 35,
                perm: "view_debtors_report",
                label: "menuitems.reports.list.debtor",
                link: "/advanced_reports/debtors_report",
                parentId: 32
            },
            {
                id: 36,
                perm: "view_payments_report",
                label: "Payments Report",
                link: "/advanced_reports/payments",
                parentId: 32
            },  
            {
                id: 37,
                perm: "view_advanced_expenses_report",
                label: "Expenses Report",
                link: "/advanced_reports/expenses_report",
                parentId: 32
            },
            {
                id: 38,
                perm: "view_audits",
                label: "Audits",
                link: "/audits",
                parentId: 32
            },           
        ]
    }
];